import { useQuery } from '@tanstack/react-query';

import { biometricApi } from '../api/biometric.adapter';

export const biometricQueryKeys = {
  all: ['biometric'] as const,
  ranges: () => [...biometricQueryKeys.all, 'ranges'] as const,
};

export function useBiometricRangesQuery() {
  return useQuery({
    queryKey: biometricQueryKeys.ranges(),
    queryFn: () => biometricApi.getRanges(),
  });
}
